var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropHorz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 24.5835C12.0342 24.5835 9.83398 26.7837 9.83398 29.5002C9.83398 32.2166 12.0342 34.4168 14.7507 34.4168C17.4671 34.4168 19.6673 32.2166 19.6673 29.5002C19.6673 26.7837 17.4671 24.5835 14.7507 24.5835ZM44.2506 24.5835C41.5342 24.5835 39.334 26.7837 39.334 29.5002C39.334 32.2166 41.5342 34.4168 44.2506 34.4168C46.9671 34.4168 49.1673 32.2166 49.1673 29.5002C49.1673 26.7837 46.9671 24.5835 44.2506 24.5835ZM29.5007 24.5835C26.7842 24.5835 24.584 26.7837 24.584 29.5002C24.584 32.2166 26.7842 34.4168 29.5007 34.4168C32.2171 34.4168 34.4173 32.2166 34.4173 29.5002C34.4173 26.7837 32.2171 24.5835 29.5007 24.5835Z",
    fill: "#8A96A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropHorz);
export default __webpack_public_path__ + "static/media/drop_horz.a7514c65a9afa4fe28ee8c60c82856e3.svg";
export { ForwardRef as ReactComponent };